const e=async(e,t,n)=>{await e.put(`/orgs/${t}`,n)};export{e as updateOrg};
//# sourceMappingURL=update-org.mjs.map